import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/static-website/src/components/layout/PageLayout/PageLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/static-website/src/components/organisms/CookieModal/CookieModalPL.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/static-website/src/components/organisms/CookieModal/CookieModalRO.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NAVIGATION_CONFIG"] */ "/var/www/static-website/src/static/content/pl/navigation.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/static-website/src/styles/cookiebot.css");
;
import(/* webpackMode: "eager", webpackExports: ["GtmProvider"] */ "/var/www/static-website/src/utils/hooks/useGTM.ts");
